<template>
  <component
    :is="darkMode ? 'crudPopUpDark' : 'crudPopUp'"
    title="Criar Cliente"
    :model="{
      nome: '',
      nif: '',
      nomeContato: '',
      email: '',
      telemovel: '',
      telefone: '',
      morada: '',
    }"
    :setData="{
      zona: { id: 0, nome: 'N/A' }
    }"
    :button_text="'Criar'"
    :mandatory_fields="['nome', 'nif', 'email', 'telemovel']"
    @close="close_crud"
    @save_form="create_client"
  />
</template>

<script>
import crudPopUp from '@/components/popUps/genericPopUp.vue'
import crudPopUpDark from '@/components/popUps/genericPopUpDark.vue'
import axios from 'axios';
import { toast } from 'vue3-toastify';

export default {
  name: 'ClientCrudPopUp',
  components: {
    crudPopUp,
    crudPopUpDark
  },
  props: {
    title: {
      type: String,
      default: 'Título'
    },
    crud_data: {
      type: Object,
      default: () => ({})
    },
    darkMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show_crud: false,
      baseURl: process.env.VUE_APP_URL_BASE,
    }
  },
  methods: {
    close_crud() {
      this.show_crud = false
      this.$emit('close')
    },
    set_entity(data) {
      this.$emit('returnData', data)
    },
    async create_client(data, setData) {
      data.tpZona_id = setData.zona.id
      const res = await this.create(data, `${this.baseURl}/api/v1/cliente/negocio/registrar/`)
      if (res) {
        this.set_entity(res)
        this.close_crud()
        toast.success("Cliente criado com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      } else {
        toast.error("Erro ao criar cliente", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      }
    },
    async create(data, url) {
      try {
        const res = await axios.post(url, data);
        return res.data.data;
      } catch (error) {
        console.error('Error getting data:', error);
      }
    },
    async select(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error('Error getting data:', error);
      }
    },
    async select_all(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error('Error getting data:', error);
      }
    },
    async update(url, data) {
      try {
        const res = await axios.put(url, data);
        return res.data.data;
      } catch (error) {
        console.error('Error posting data:', error);
      }
    },
    async remove(url) {
      try {
        await axios.delete(url);
        return true;
      } catch (error) {
        console.error('Error deleting data:', error);
      }
    },
  }
}
</script>